import React, { useState, useRef } from "react";
import { Formik } from "formik";
import DataTable from "react-data-table-component";
import { HemaLabel, Button, QuantityButton, FormText, FormTitle, Alert, HemaValue } from "../../utils";
import LoginInput from "../../utils/FormElements/loginInput";
import Select from "../../utils/FormElements/select";
import SingleSelect from "../../utils/FormElements/singleSelect";
import Modal from "react-bootstrap/Modal";
import {
  BuyIcon,
  Location,
  CrossIcon,
  Confirm,
  Cancel,
  Binocular,
  Phone,
  Email,
  Marker,
  City,
  State,
  ZipCode,
  Flag,
  CreateItem,
  Share,
  User,
  BlueTick,
  FileIcon,
  NameIcon,
  Calendar,
} from "../../HemeIconLibrary";
import { useDispatch } from "react-redux";
import { Spinner, Alert as BootstrapAlert } from "react-bootstrap";
import { setItemCount, setAddToCart } from "../../Store/reducers/orders";

import { setForm, showSuccessReducer } from "../../Store/reducers/uiSettings";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import cart from "../../assets/images/cart.png";
import SettingForm from "../../components/auth/selectSettings";
import { shareNewOrder, deleteAddressAction, createNewAddresses, getAllAddresses, editAddressesAction } from "../../Actions/orders";
import { compareArrays } from "../../helpers/commonHelper";
import Skeleton from "react-loading-skeleton";
import { changeReason } from "./AllForms/addStorageLocation";
import { ca } from "date-fns/locale";

const FormikForm = ({ onFormClose, cancelText, CancelIcon, confirmText }) => {
  const navigate = useNavigate();
  const { uisettings, orders, user } = useSelector((state) => state);
  const [show, setShow] = useState(false);
  console.log("orders", orders);

  const dispatch = useDispatch();

  //
  const formikRef = useRef();

  const changeQuantity = (data, count) => {
    dispatch(setItemCount({ data: data, count: count }));
  };

  const LIMITS = {
    name: 35,
    address1: 35,
    address2: 35,
    department: 35,
    city: 35,
    stateProvince: 30,
    postalCode: 10,
    email: 50,
    phone: 15,
    changeReason: 200,
  };

  const capChange =
    (field, setFieldValue, extraSanitize) =>
    (e) => {
      let v = e.target.value ?? "";
      if (typeof extraSanitize === "function") v = extraSanitize(v);
      const limit = LIMITS[field] ?? Number.MAX_SAFE_INTEGER;
      if (v.length > limit) v = v.slice(0, limit);
      setFieldValue(field, v, true);
    };

  const atLimit = (value = "", field) => (value?.length || 0) >= (LIMITS[field] || 0);

  const LimitHelper = ({ value = "", field }) =>
  atLimit(value, field) ? (
    <p className="m-0 text-xs text-[#6C757D]">
      You’ve reached the {LIMITS[field]}-character limit.
    </p>
  ) : null;

  const addToCart = (data, status) => {
    const getCartItemsFromLocal = localStorage.getItem("cart-item-ids");

    if (status === true) {
      localStorage.setItem("cart-item-ids", [getCartItemsFromLocal, data.id]);
    } else {
      localStorage.setItem(
        "cart-item-ids",
        getCartItemsFromLocal.split(",")?.filter((id) => id !== String(data.id)),
      );
    }
    dispatch(setAddToCart({ data, status }));
  };

  const customStyles = {
    headCells: {
      style: {
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "18px",
        color: "#000000",
        // minHeight: '40px !important',
      },
    },
    responsiveWrapper: {
      style: { overflow: "visible !important" },
    },

    cells: {
      style: {
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "18px",
        color: "#595959",
      },
    },
  };

  return uisettings.formName === "show-cart" ? (
    <div className="h-[96%] flex flex-col justify-between collection-card ">
      <div className="pb-[25px]">
        <FormTitle fontSize="31px" fontLineHeight="31px" fontWeight="600" Icon={<BuyIcon color=" #716EC6" width="40" height="40" />} text="Cart" />
      </div>

      <div className="w-full border-b border-dashed border-[#DEE2E6]  mb-[25px]" />
      <div className="overflow-auto h-[744px]">
        {orders.allKitsforSite
          ?.filter((data) => data.addtocart)
          ?.map((kit, index) => {
            return (
              <>
                <div key={kit.id} className={`flex gap-8 items-center  mb-[18px] ${index > 0 && "pt-[18px] border-t"} border-solid border-borderColor `}>
                  <img src={cart} alt="" className="w-[100px] h-[100px] object-cover" />
                  <div className="flex flex-col">
                    <h5 className="m-0 text-base font-bold text-mainheadingColor">{kit.name}</h5>
                    <div className="flex flex-wrap items-center gap-5">
                      <p className="m-0 text-base font-normal text-textColor">Quantity :</p>
                      <QuantityButton changeQuantity={changeQuantity} data={kit} deleteIcon cta={addToCart} />

                      <Button
                        cta={() => {
                          setShow(true);
                        }}
                        type="button"
                        text="Remove"
                        bg="bg-white"
                        border="border-primary1"
                        color="text-primary1"
                      />
                    </div>
                  </div>
                </div>
                <Modal
                  size="md"
                  backdropClassName="cart_modal"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  show={show}
                  onHide={() => setShow(false)}
                  animation={false}
                >
                  <Modal.Body>
                    <p className="m-0 text-base font-semibold text-center">Would you like to remove the item from your cart?</p>
                  </Modal.Body>

                  <Modal.Footer>
                    <div className="flex gap-[20px]  items-center justify-center w-full">
                      <p
                        className="m-0 text-base font-semibold cursor-pointer user-down-item"
                        href=""
                        onClick={() => {
                          addToCart(kit, false);
                          setShow(false);
                        }}
                      >
                        Yes
                      </p>
                      <p className="m-0 text-base font-semibold cursor-pointer user-down-item" href="" onClick={() => setShow(false)}>
                        No
                      </p>
                    </div>
                  </Modal.Footer>
                </Modal>
              </>
            );
          })}
        {orders.allKitsforSite?.filter((data) => data.addtocart).length === 0 && <BootstrapAlert variant="warning">No Item added to Cart</BootstrapAlert>}
      </div>

      <div className="flex gap-[8px] justify-end my-[20px]">
        <Button
          cta={() => {
            if (onFormClose) {
              onFormClose();
            }
            dispatch(setForm({ state: false, type: "" }));
          }}
          type="button"
          text={orders?.allKitsforSite?.filter((data) => data.addtocart)?.length > 0 ? cancelText || "Cancel" : "Close" || "Cancel"}
          bg="bg-white"
          border="border-primary1"
          color="text-primary1"
          Icon={CancelIcon || <Cancel />}
        />

        {uisettings.formLoader ? (
          <Button
            type="submit"
            bg="bg-primary1"
            text={
              <>
                <Spinner animation="grow" size="sm" variant="light" />
                <Spinner animation="grow" size="sm" variant="light" />
                <Spinner animation="grow" size="sm" variant="light" />
              </>
            }
          />
        ) : (
          !!orders.allKitsforSite?.filter((data) => data.addtocart).length && (
            <Button
              type="submit"
              text={confirmText || "Checkout"}
              bg="bg-primary1"
              color="text-white"
              Icon={<BlueTick color="#FFFFFF" /> || <Confirm />}
              cta={() => {
                dispatch(setForm({ state: false, type: "" }));
                navigate("/checkout");
              }}
            />
          )
        )}
      </div>
    </div>
  ) : uisettings.formName === "edit-user-status" ? (
    <>
      <SettingForm loginUser={true} />
    </>
  ) : uisettings.formName === "share-order" ? (
    <>
      <Formik
        initialValues={{
          name: "",
          email: "",
        }}
        enableReinitialize
        validate={(values) => {
          const errors = {};
          if (!values.name) {
            errors.name = "Required";
          }
          if (!values.email) {
            errors.email = "Required";
          }

          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const result = await shareNewOrder(orders.activeAddressId, values);
          setSubmitting(false);
          if (result.status === 200) {
            dispatch(setForm({ state: false, type: "" }));
            dispatch(showSuccessReducer(`Your order has been shared to ${values.email}`));
          }
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting, /* and other goodies */ n }) => (
          <>
            <div className="">
              <FormTitle fontSize="26px" fontLineHeight="31px" fontWeight="600" Icon={<Share />} text="Share the Order" />
            </div>

            <div className="w-full border-b border-dashed border-[#DEE2E6]  mt-[25px] mb-[23px]" />

            <form onSubmit={handleSubmit}>
              <div className="flex flex-col  mb-[24px] mt-[24px]">
                <HemaLabel text="User Name" Icon={<User />} textSize="text-[16px]" required={true} className="pb-[15px]" />
                <FormText type="text" name="name" placeholder="Enter your Email" value={values.name} onChange={handleChange} onBlur={handleBlur} setFieldValue={setFieldValue} />
                {errors.name && touched.name && <p className="error m-0  text-[#F54C3B]"> {errors.name}</p>}
              </div>

              <div className="flex flex-col  mb-[24px] mt-[24px]">
                <HemaLabel text="Email" Icon={<Email width="14" height="14" color="#605DAF" />} textSize="text-[16px]" required={true} className="pb-[15px]" />
                <FormText type="email" name="email" placeholder="Enter your Email" value={values.email} onChange={handleChange} onBlur={handleBlur} setFieldValue={setFieldValue} />

                {errors.email && touched.email && <p className="error m-0  text-[#F54C3B]"> {errors.email}</p>}
              </div>

              <div className="mt-[24px]">
                <Alert />
              </div>
              <div className=" w-full flex justify-end gap-[20px]">
                {isSubmitting ? (
                  <Button
                    type="submit"
                    bg="bg-primary1"
                    className="w-full h-[48px] justify-center font-semibold"
                    text={
                      <>
                        <Spinner animation="grow" size="sm" variant="light" />
                        <Spinner animation="grow" size="sm" variant="light" />
                        <Spinner animation="grow" size="sm" variant="light" />
                      </>
                    }
                  />
                ) : (
                  <Button text="Share" type="submit" bg="bg-primary1" border="border-primary1" color="text-white" className="w-full h-[48px] justify-center font-semibold" />
                )}
              </div>
            </form>
          </>
        )}
      </Formik>
    </>
  ) : uisettings.formName === "order-detail-shipment" ? (
    <>
      <div className="h-[96%] flex flex-col justify-between">
        <div className="h-full">
          <div className="pb-[25px]">
            <FormTitle fontSize="31px" fontLineHeight="31px" fontWeight="600" Icon={<CreateItem />} text="Shipment Information" />
          </div>
          {orders.orderDetail ? (
            <>
              <div className="border-[1px] border-solid border-[#DEE2E6] overflow-auto order_shipment_table">
                <DataTable
                  customStyles={customStyles}
                  data={orders.orderDetail?.shipments || []}
                  columns={[
                    {
                      width: "23%",
                      name: "Tracking Number",
                      selector: (row) => <div className="">
                        <a
                          className="no-underline"
                          href={
                            row?.courier?.id === 1
                              ? `https://www.fedex.com/fedextrack/?action=track&tracknumbers=${row?.trackingNumber}`
                              : `https://www.dhl.com/global-en/home/tracking/tracking-express.html?submit=1&tracking-id=${row?.trackingNumber}`
                          }
                          target="_blank"
                        >
                          <HemaValue
                            className="text-xs font-normal "
                            text={row?.trackingNumber}
                          />
                        </a>
                      </div>,
                    },
                    
                    {
                      width: "21%",
                      name: "Status",
                      selector: (row) => {
                        return <div className={` bg-lavenderMist text-primary2  rounded-full px-4 py-[2px]`}>{row?.status?.name}</div>;
                      },
                    },
                    {
                      width: "16%",
                      name: "Number of Packages",
                      selector: (row) => <div className="">{row?.numberOfPackages}</div>,
                    },
                    {
                      width: "25%",
                      center: true,
                      name: "Shipping Date",
                      selector: (row) => {
                        return (
                          <div className="flex items-center gap-1">
                            <HemaLabel /> {row?.shippedUtc?.split("T")[0]}
                          </div>
                        )
                      },
                    },
                    {
                      width: "15%",
                      name: "Packaging Slip",
                      selector: (row) => {
                        return (
                          <div className="flex items-center gap-1">
                            <Button
                              Icon={<Binocular />}
                              disabled={!row?.packingSlip?.storageUrl}
                              color="text-white"
                              cta={async () => {
                                if (!row?.packingSlip?.storageUrl) return;
                                try {
                                  const response = await fetch(row.packingSlip.storageUrl);
                                  const blob = await response.blob();
                                  const url = window.URL.createObjectURL(blob);
                                  const a = document.createElement("a");
                                  a.href = url;
                                  a.download = row.packingSlip.friendlyName;
                                  document.body.appendChild(a);
                                  a.click();
                                  a.remove();
                                  window.URL.revokeObjectURL(url);
                                } catch (err) {
                                  console.error("Failed to download packing slip:", err);
                                }
                              }}
                            />
                          </div>
                        );
                      },
                    },
                  ]}
                />
              </div>
            </>
          ) : (
            <div>
              <Skeleton count="4" />
              <br />
              <Skeleton count="4" />
            </div>
          )}
        </div>
        <div className=" w-full flex justify-end gap-[20px] mb-[20px]">
          <Button
            type="button"
            text={"Close"}
            bg="bg-white"
            border="border-primary1"
            color="text-primary1"
            Icon={<Cancel />}
            cta={() => {
              dispatch(setForm({ state: false, type: "" }));
            }}
          />
        </div>
      </div>
    </>
  ) : uisettings.formName === "order-detail-form" ? (
    <>
      <div className="h-[94%] flex flex-col justify-between overflow-y-auto">
        <div className="h-full">
          <div className="pb-[25px]">
            <FormTitle fontSize="31px" fontLineHeight="31px" fontWeight="600" Icon={<CreateItem />} text="Order Details" />
          </div>
          <div className="flex flex-row mb-[25px]">
            <HemaValue className="w-[40%] pr-[29px]" text={"Order Confirmation #"} />
            <HemaValue className="text-[#595959]" color="#595959" text={orders.orderDetail?.orderCode} />
          </div>
          <div className="flex flex-row mb-[25px]">
            <HemaValue className="w-[40%] pr-[61px]" text={"Requestor Name"} />
            <HemaValue className="text-[#595959]" color="#595959" text={orders.orderDetail?.requesterName} />
          </div>
          <div className="flex flex-row mb-[25px]">
            <HemaValue className="w-[40%] pr-[62px]" text={"Requestor Email"} />
            <HemaValue className="text-[#595959]" color="#595959" text={orders.orderDetail?.requesterEmail} />
          </div>
          <div className="flex flex-row mb-[25px]">
            <HemaValue className="w-[40%] pr-[62px]" text={"Requested Date"} />
            <HemaValue className="text-[#595959]" color="#595959" text={orders.orderDetail?.createdUtc} />
          </div>
          <div className="flex flex-row mb-[25px]">
            <HemaValue className="w-[40%] pr-[62px]" text={"Needed By Date"} />
            <HemaValue className="text-[#595959]" color="#595959" text={orders.orderDetail?.neededDate} />
          </div>
          <div className="border-[1px]  border-solid border-[#DEE2E6]">
            <DataTable
              customStyles={customStyles}
              data={orders.orderDetail?.items || []}
              columns={[
                {
                  name: "Item Name",
                  selector: (row, index) => {
                    return <div className="flex-shrink-0 flex items-center gap-[10px] cursor-pointer check_box">{row.item.name}</div>;
                  },
                },
                {
                  name: "Total Quantity",
                  cell: (row, index) => {
                    return <div className="flex-shrink-0 flex items-center gap-[10px] cursor-pointer check_box">{row.quantity}</div>;
                  },
                },
              ]}
            />
          </div>
        </div>
        <div className=" w-full flex justify-end gap-[20px] mb-[20px]">
          <Button
            type="button"
            text={"Close"}
            bg="bg-white"
            border="border-primary1"
            color="text-primary1"
            Icon={<Cancel />}
            cta={() => {
              dispatch(setForm({ state: false, type: "" }));
            }}
          />
        </div>
      </div>
    </>
  ) : uisettings.formName === "delete-address" ? (
    <>
      <div className="h-[94%] flex flex-col justify-between overflow-y-auto">
        <div className="h-full">
          <div className="pb-[25px]">
            <FormTitle fontSize="31px" fontLineHeight="31px" fontWeight="600" text="Delete Address" />
          </div>
          <Formik
            initialValues={{
              name: uisettings?.editForm?.id ? uisettings?.editForm?.name : "",
              address1: uisettings?.editForm?.id ? uisettings?.editForm?.address1 : "",
              address2: uisettings?.editForm?.id ? uisettings?.editForm?.address2 : "",
              department: uisettings?.editForm?.id ? uisettings?.editForm?.department : "",
              city: uisettings?.editForm?.id ? uisettings?.editForm?.city : "",
              stateProvince: uisettings?.editForm?.id ? uisettings?.editForm?.stateProvince : "",
              postalCode: uisettings?.editForm?.id ? uisettings?.editForm?.postalCode : "",
              countryId: uisettings?.editForm?.id ? uisettings?.editForm?.country?.name : "",

              email: uisettings?.editForm?.id ? uisettings?.editForm?.email : "",
              phone: uisettings?.editForm?.id ? uisettings?.editForm?.phone : "",

              changeReason: "",
            }}
            validate={(values) => {
              const errors = {};
              if (!values.changeReason) {
                errors.changeReason = "Required";
              }
              if (values.changeReason?.length > 200) {
                errors.changeReason = "Max 200 characters allowed";
              }
              return errors;
            }}
            onSubmit={async (values) => {
              const result = await deleteAddressAction(uisettings?.editForm?.id, values.changeReason);

              if (result.status === 200) {
                dispatch(setForm({ state: false, type: "" }));
                dispatch(showSuccessReducer(`Address has been deleted.`));
              }
            }}
          >
            {({ errors, values, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting }) => (
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col justify-between mb-[25px] h-[78vh]">
                  <div className="">
                    <HemaValue className="w-[40%] pr-[17px]" text={"Are you sure you want to delete this address? This action cannot be undone."} />
                    <div className="mt-[24px] mb-3">
                      <Alert type="error" />
                    </div>
                    <div className="mb-[25px]">
                    <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"Name"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.name} />
                      </div>
                      <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"Address 1"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.address1} />
                      </div>
                      <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"Address 2"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.address2} />
                      </div>
                      <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"Department"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.department} />
                      </div>
                      <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"City"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.city} />
                      </div>
                      <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"State/Province"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.stateProvince} />
                      </div>
                      <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"Zip/Postal Code"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.postalCode} />
                      </div>
                      <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"Country"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.countryId} />
                      </div>
                      <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"Email"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.email} />
                      </div>
                      <div className="flex w-full gap-[16px]">
                        <HemaValue className="w-full max-w-[160px] pb-[16px]" color="#000000" text={"Phone Number"} />
                        <HemaValue className="text-[#595959]" color="#595959" text={values?.phone} />
                      </div>
                    </div>
                    <div className="">
                      <HemaLabel required text="Change Reason" Icon={<FileIcon color="#605DAF" />} textSize="text-[12px]" />
                      <LoginInput
                        type="textarea"
                        name="changeReason"
                        placeholder="Enter change reason"
                        value={values.changeReason}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        setFieldValue={setFieldValue}
                      />
                      <p className="error m-0  text-[#F54C3B]">{errors.changeReason && touched.changeReason && errors.changeReason}</p>
                    </div>
                  </div>

                  <div className=" w-full flex justify-end gap-[20px]">
                    <Button
                      type="button"
                      text={cancelText || "Cancel"}
                      bg="bg-white"
                      border="border-primary1"
                      color="text-primary1"
                      Icon={<Cancel />}
                      cta={() => {
                        dispatch(setForm({ state: false, type: "" }));
                      }}
                    />

                    {isSubmitting ? (
                      <Button
                        type="button"
                        bg="bg-primary1"
                        className="h-[48px] justify-center font-semibold"
                        text={
                          <>
                            <Spinner animation="grow" size="sm" variant="light" />
                            <Spinner animation="grow" size="sm" variant="light" />
                            <Spinner animation="grow" size="sm" variant="light" />
                          </>
                        }
                      />
                    ) : (
                      <Button
                        text="Confirm"
                        type="submit"
                        bg="bg-primary1"
                        border="border-primary1"
                        color="text-white"
                        disabled={values.changeReason && Object.keys(errors)?.length === 0 ? false : true}
                        Icon={<Confirm />}
                        className="h-[48px] justify-center font-semibold"
                      />
                    )}
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  ) : uisettings.formName === "add-address-book" ? (
    <>
      <div className="h-[94%] flex flex-col justify-between overflow-y-auto">
        <div className="h-full">
          <div className="mb-[33px]">
            <FormTitle fontSize="text-[26px]" fontLineHeight="leading-[31px]" fontWeight="font-[600]" text={uisettings?.editForm?.id ? "Edit Address" : "Add New Address"} />
          </div>

          <Alert type="error" />

          <div className="h-[80%]">
            <Formik
              initialValues={{
                name: uisettings?.editForm?.id ? uisettings?.editForm?.name : "",
                address1: uisettings?.editForm?.id ? uisettings?.editForm?.address1 : "",
                address2: uisettings?.editForm?.id ? uisettings?.editForm?.address2 : "",
                department: uisettings?.editForm?.id ? uisettings?.editForm?.department : "",
                city: uisettings?.editForm?.id ? uisettings?.editForm?.city : "",
                stateProvince: uisettings?.editForm?.id ? uisettings?.editForm?.stateProvince : "",
                postalCode: uisettings?.editForm?.id ? uisettings?.editForm?.postalCode : "",
                countryId: uisettings?.editForm?.id ? uisettings?.editForm?.country : "",

                email: uisettings?.editForm?.id ? uisettings?.editForm?.email : "",
                phone: uisettings?.editForm?.id ? uisettings?.editForm?.phone : "",
                changeReason: "",
              }}
              innerRef={formikRef}
              enableReinitialize
              validate={(values) => {
                const errors = {};

                if (!values.name) {
                  errors.name = "Required";
                }
                if (!values.address1) {
                  errors.address1 = "Required";
                }
                if (!values.city) {
                  errors.city = "Required";
                }
                if (!values.email) {
                  errors.email = "Required";
                } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                  errors.email = "Please enter correct email format";
                }
                if (!values.phone) {
                  errors.phone = "Required";
                }
                if (!values.countryId) {
                  errors.countryId = "Required";
                }
                if (values.countryId?.length === 0) {
                  errors.countryId = "Required";
                }
                if (uisettings?.editForm?.id) {
                  if (!values.changeReason) {
                    errors.changeReason = "Required";
                  }
                }
                return errors;
              }}
              onSubmit={async (values) => {
                if (uisettings?.editForm?.id) {
                  const editaddress = await editAddressesAction(uisettings?.editForm?.id, {
                    ...values,
                    phone: values.phone?.toString(),
                    countryId: values.countryId?.id,
                    siteId: user?.activeSite?.id,
                  });

                  if (editaddress.status === 200) {
                    getAllAddresses(user?.activeSite?.id);
                    dispatch(setForm({ state: false, type: "" }));
                    dispatch(showSuccessReducer(`Address has been edited.`));
                  }
                } else {
                  const createNewaddress = await createNewAddresses({
                    ...values,
                    phone: values.phone?.toString(),
                    countryId: values.countryId?.id,
                    siteId: user?.activeSite?.id,
                  });

                  if (createNewaddress.status === 200) {
                    getAllAddresses(user?.activeSite?.id);
                    dispatch(setForm({ state: false, type: "" }));
                    dispatch(showSuccessReducer(`Address has been created.`));
                  }
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                initialValues,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting,
                /* and other goodies */
              }) => (
                <>
                  <form onSubmit={handleSubmit} className="shopping_cart_form">
                    <div className="">
                    <div className="flex flex-col items-start justify-between w-full gap-4 mb-4 sm:flex-row">
                        <div className="flex flex-col w-full input_div">
                          <HemaLabel required text="Name" Icon={<NameIcon color="#605DAF" />} textSize="text-[12px]" />
                          <LoginInput
                            type="text"
                            name="name"
                            placeholder="Enter name"
                            crossIcon={values.name ? <CrossIcon /> : ""}
                            value={values.name}
                            onChange={capChange("name", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                            maxLength={LIMITS.name}
                          />
                          <LimitHelper value={values.name} field="name" />
                          <p className="error m-0  text-[#F54C3B]">{errors.name && touched.name && errors.name}</p>
                        </div>
                      </div>
                      <div className="flex flex-col items-start justify-between w-full gap-4 mb-4 sm:flex-row">
                        <div className="flex flex-col w-full input_div">
                          <HemaLabel required text="Address 1" Icon={<Location color="#605DAF" />} textSize="text-[12px]" />
                          <LoginInput
                            type="text"
                            name="address1"
                            placeholder="Enter address"
                            crossIcon={values.address1 ? <CrossIcon /> : ""}
                            value={values.address1}
                            onChange={capChange("address1", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <LimitHelper value={values.address1} field="address1" />
                          <p className="error m-0  text-[#F54C3B]">{errors.address1 && touched.address1 && errors.address1}</p>
                        </div>
                      </div>
                      <div className="flex flex-col items-start justify-between w-full gap-4 my-4 sm:flex-row">
                        <div className="flex flex-col w-full input_div">
                          <HemaLabel text="Address 2" textSize="text-[12px]" Icon={<Marker color="#605DAF" />} />
                          <LoginInput
                            type="text"
                            name="address2"
                            placeholder="Enter address 2"
                            crossIcon={values.address2 ? <CrossIcon /> : ""}
                            value={values.address2}
                            onChange={capChange("address2", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <LimitHelper value={values.address2} field="address2" />
                          <p className="error m-0  text-[#F54C3B]">{errors.address2 && touched.address2 && errors.address2}</p>
                        </div>
                      </div>


                      <div className="flex flex-col items-start justify-between w-full gap-4 my-4 sm:flex-row">
                        <div className="flex flex-col w-full input_div">
                          <HemaLabel text="Department" textSize="text-[12px]" Icon={<Marker color="#605DAF" />} />
                          <LoginInput
                            type="text"
                            name="department"
                            placeholder="Enter department"
                            crossIcon={values.department ? <CrossIcon /> : ""}
                            value={values.department}
                            onChange={capChange("department", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <LimitHelper value={values.department} field="department" />
                          <p className="error m-0  text-[#F54C3B]">{errors.department && touched.department && errors.department}</p>
                        </div>
                      </div>

                      <div className="flex flex-col items-start justify-between w-full gap-4 mb-4 sm:flex-row">
                        <div className="flex flex-col w-full input_div">
                          <HemaLabel required Icon={<City color="#605DAF" />} text="City" textSize="text-[12px]" className="pb-[10px]" />
                          <LoginInput
                            type="text"
                            name="city"
                            placeholder="Enter city name"
                            crossIcon={values.city ? <CrossIcon /> : ""}
                            value={values.city}
                            onChange={capChange("city", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <LimitHelper value={values.city} field="city" />
                          {errors.city && touched.city && <p className="error m-0  text-[#F54C3B]"> {errors.city}</p>}
                        </div>
                        <div className="flex flex-col w-full input_div">
                          <HemaLabel Icon={<State color="#605DAF" />} text="State/Province" textSize="text-[12px]" className="pb-[10px]" />

                          <LoginInput
                            type="text"
                            name="stateProvince"
                            placeholder="Enter state/province name"
                            crossIcon={values.stateProvince ? <CrossIcon /> : ""}
                            value={values.stateProvince}
                            onChange={capChange("stateProvince", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <LimitHelper value={values.stateProvince} field="stateProvince" />
                          {errors.stateProvince && touched.stateProvince && <p className="error m-0  text-[#F54C3B]"> {errors.stateProvince}</p>}
                        </div>
                      </div>

                      <div className="flex flex-col items-start justify-between w-full gap-4 mb-4 sm:flex-row">
                        <div className="flex flex-col w-full input_div">
                          <HemaLabel Icon={<ZipCode color="#605DAF" />} text="Zip/Postal Code" textSize="text-[12px]" />
                          <LoginInput
                            type="text"
                            name="postalCode"
                            placeholder="Zip/Postal Code"
                            crossIcon={values.postalCode ? <CrossIcon /> : ""}
                            value={values.postalCode}
                            onChange={capChange("postalCode", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <LimitHelper value={values.postalCode} field="postalCode" />
                          <p className="error m-0  text-[#F54C3B]">{errors.postalCode && touched.postalCode && errors.postalCode}</p>
                        </div>
                        <div className="flex flex-col w-full">
                          <HemaLabel required text="Country" Icon={<Flag color="#605DAF" />} textSize="text-[12px]" className="pb-[10px]" />
                          <SingleSelect
                            formikRef={formikRef}
                            setFieldValueFull={setFieldValue}
                            name="countryId"
                            placeholder={uisettings?.editForm?.id ? uisettings?.editForm?.country?.name : "Select country"}
                            initialValues={values.countryId}
                            crossIcon={values.countryId.name ? <CrossIcon /> : ""}
                            options={orders?.countries || []}
                            value={values?.countryId?.id}
                            dispatch={dispatch}
                            // dropIcon={<SelectDownArrow />}
                          />

                          {errors.countryId && touched.countryId && <p className="error m-0  text-[#F54C3B]"> {errors.countryId}</p>}
                        </div>
                      </div>

                      <div className="flex flex-col items-start justify-between w-full gap-4 mb-4 sm:flex-row">
                        <div className="flex flex-col w-full input_div">
                          <HemaLabel required Icon={<Email color="#605DAF" />} text="Email" textSize="text-[12px]" />
                          <LoginInput
                            type="text"
                            name="email"
                            placeholder="Enter Email"
                            crossIcon={values.email ? <CrossIcon /> : ""}
                            value={values.email}
                            onChange={capChange("email", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <LimitHelper value={values.email} field="email" />
                          <p className="error m-0  text-[#F54C3B]">{errors.email && touched.email && errors.email}</p>
                        </div>
                        <div className="flex flex-col w-full input_number_div">
                          <HemaLabel Icon={<Phone color="#605DAF" />} required text="Phone Number" textSize="text-[12px]" />
                          <LoginInput
                            type="number"
                            name="phone"
                            min="0"
                            placeholder="Enter Phone Number"
                            crossIcon={values.phone ? <CrossIcon /> : ""}
                            value={values.phone}
                            onChange={capChange("phone", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <LimitHelper value={values.phone} field="phone" />
                          <p className="error m-0  text-[#F54C3B]">{errors.phone && touched.phone && errors.phone}</p>
                        </div>
                      </div>
                      {uisettings?.editForm?.id && (
                        <div className="">
                          <HemaLabel required text="Change Reason" Icon={<FileIcon color="#605DAF" />} textSize="text-[12px]" />
                          <LoginInput
                            type="textarea"
                            name="changeReason"
                            placeholder="Enter change reason"
                            value={values.changeReason}
                            onChange={capChange("changeReason", setFieldValue)}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <LimitHelper value={values.changeReason} field="changeReason" />
                          <p className="error m-0  text-[#F54C3B]">{errors.changeReason && touched.changeReason && errors.changeReason}</p>
                        </div>
                      )}
                    </div>
                    <div className=" w-full flex justify-end gap-[20px]">
                      <Button
                        type="button"
                        text={cancelText || "Cancel"}
                        bg="bg-white"
                        border="border-primary1"
                        color="text-primary1"
                        Icon={<Cancel />}
                        cta={() => {
                          dispatch(setForm({ state: false, type: "" }));
                        }}
                      />

                      {isSubmitting ? (
                        <Button
                          type="button"
                          bg="bg-primary1"
                          className="h-[48px] justify-center font-semibold"
                          text={
                            <>
                              <Spinner animation="grow" size="sm" variant="light" />
                              <Spinner animation="grow" size="sm" variant="light" />
                              <Spinner animation="grow" size="sm" variant="light" />
                            </>
                          }
                        />
                      ) : (
                        <Button
                          text={uisettings?.editForm?.id ? "Update" : "Create"}
                          type="submit"
                          bg="bg-primary1"
                          border="border-primary1"
                          color="text-white"
                          Icon={<Confirm />}
                          // disabled={
                          //   values.address1 && values.email && values.city && values.phone && values.countryId
                          //     ? uisettings?.editForm?.id || compareArrays(initialValues, values)
                          //       ? true
                          //       : Object.keys(errors)?.length
                          //       ? true
                          //       : false
                          //     : values.changeReason
                          //     ? false
                          //     : true
                          // }
                          disabled={compareArrays(initialValues, values) ? true : Object.keys(errors)?.length ? true : false}
                          className="h-[48px] justify-center font-semibold"
                        />
                      )}
                    </div>
                  </form>
                </>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div></div>
  );
};

export default FormikForm;
